var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-modal', {
    attrs: {
      "active": _vm.active
    },
    on: {
      "close": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (2),
      expression: "2"
    }]
  }, [_c('v-row', [_c('v-col'), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "8"
    }
  }, [_c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.top",
      value: (1),
      expression: "1",
      modifiers: {
        "top": true
      }
    }, {
      name: "text-align",
      rawName: "v-text-align.center",
      modifiers: {
        "center": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling"
    }
  }, [_vm._v("\n                        Пользовательское соглашение\n                    ")])], 1)]), _vm._v(" "), _c('v-col', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.right",
      modifiers: {
        "right": true
      }
    }]
  }, [_c('v-icon-button', {
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("\n                    clear\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling",
      "bold": ""
    }
  }, [_vm._v("\n                1. Термины и определения\n            ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_c('strong', [_vm._v("Сайт")]), _vm._v(" – совокупность размещенных в сети электронных документов (файлов), объединенных единой темой, дизайном и адресным пространством домена unirate24.ru Стартовая страница Сайта размещена в сети Интернет по адресу\n                "), _c('v-link', {
    attrs: {
      "target": "_blank",
      "to": "http://unirate24.ru"
    }
  }, [_vm._v("\n                    http://unirate24.ru\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_c('strong', [_vm._v("Администрация сайта (Администрация)")]), _vm._v(" – Администрация сайта «unirate24.ru»\n                "), _c('v-link', {
    attrs: {
      "target": "_blank",
      "to": "http://unirate24.ru"
    }
  }, [_vm._v("\n                    http://unirate24.ru\n                ")]), _vm._v(" в лице технического директора, глав клиентского отдела и отдела технической поддержки клиентов, главного редактора.\n            ")], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_c('strong', [_vm._v("Пользователь Сайта (Пользователь)")]), _vm._v(" – лицо, прошедшее Процедуру регистрации, получившее индивидуальный логин и/или пароль, а также имеющее свой Профиль. Для целей Пользовательского соглашения под Пользователем понимается также лицо, которое не прошло Процедуру регистрации, но осуществляет доступ к Сайту и/или использует и/или использовало его. Любое лицо, осуществляющее доступ к Сайту, этим автоматически подтверждает, что оно полностью согласно с положениями Пользовательского соглашения, и что в отношении него применимы требования, установленные Пользовательским соглашением.\n            ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_c('strong', [_vm._v("Контент пользователя (Контент)")]), _vm._v(" – любая текстовая и графическая информация Пользователя, оставляемая им на Сайте в виде статей, комментариев, жалоб, сообщений, Персональных Сообщений (ПС) другим Пользователям, постов и иных видах.\n            ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling",
      "bold": ""
    }
  }, [_vm._v("\n                2. Основные аспекты\n            ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-list', {
    attrs: {
      "number": ""
    }
  }, [_c('v-list-item', [_vm._v("\n                    Настоящее Соглашение является публичной офертой Администрации сайта, и его условия обязательны для всех Пользователей.\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Настоящее Соглашение представляет собой публичную оферту, в соответствии со ст. 435 ГК РФ. Согласие Пользователя с условиями настоящего Соглашения (акцептом) считается фактическое пользование Сайтом, его сервисами и результатами интеллектуальной деятельности размещенными на нем.\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Для получения возможности пользования Сайтом необходимо ознакомиться и согласиться с текстом данного Соглашения. Если Пользователь начал пользоваться Сайтом, то это рассматривается как полное и безоговорочное согласие с текстом данного Соглашения.\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling",
      "bold": ""
    }
  }, [_vm._v("\n                3. Регистрация пользователя\n            ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-list', {
    attrs: {
      "number": ""
    }
  }, [_c('v-list-item', [_vm._v("\n                    Регистрируясь на Сайте, Пользователь обязуется предоставить при регистрации актуальную, точную и полную информацию о себе или о своей компании, которая может быть запрошена от Пользователя регистрационными формами Сайта.\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Пользователь соглашается с тем, что несет персональную ответственность (перед Администрацией и иными лицами) за любые действия, совершаемые третьими лицами посредством его учетной записи, а также за любые последствия, которые могло повлечь или повлекло подобное ее использование.\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Пользователь обязуется принимать необходимые меры для обеспечения сохранности своего логина и пароля для доступа в Аккаунт.\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Оставляя свои контактные данные, Пользователь дает свое безусловное согласие на хранение, обработку и использование своих контактных данных, в том числе и для передачи их лицам, которые могут помочь в разрешении описанной Пользователем проблемы (по их запросу), а именно: официальным представителям компании-ответчика, представителям Государственных структур, представителям Средств Массовой Информации.\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Оставляя свои контактные данные, Пользователь дает свое безусловное согласие на получение писем от Администрации на e-mail Пользователя, на звонки Администрации на телефоны Пользователя с целью контроля качества услуг Администрацией, предложения новых услуг Администрацией Пользователю, информирования Пользователя о работе Сайта Администрацией.\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling",
      "bold": ""
    }
  }, [_vm._v("\n                4. Обязанности Пользователя\n            ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_vm._v("\n                Пользователь обязуется:\n            ")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "number": ""
    }
  }, [_c('v-list-item', [_vm._v("\n                    Не регистрировать Аккаунт от имени лица, которым не является (фальшивый Аккаунт), или действовать от имени организации, компании, марки, юридического или физического лица и пр., чьи интересы он не уполномочен представлять;\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Не совершать никаких действий, имеющих цель получить доступ к Сайту путем направления на серверы такого количества запросов в течение установленной единицы времени, которое реальный Пользователь не сможет направить в такой же период посредством использования общедоступного стандартного веб-браузера;\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Не распространять, не изменять фрагмент или фрагменты Сайта, не вмешиваться в его работу, нарушая ее, любыми средствами и способами;\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Не получать доступ к Сайту или к размещенному на Сайте Контенту посредством какой-либо технологии или средств (программы, скрипты и проч.), не предусмотренных или не расположенных специально на Сайте;\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Не использовать Сайт в любых коммерческих целях без предварительного письменного разрешения Администрации;\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Не запрашивать у других Пользователей пароли и другую идентификационную информацию для ее неправомерного использования, а также в коммерческих или корыстных целях;\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Не размещать на Сайте домашние адреса, номера телефонов, адреса электронной почты, паспортные данные и прочую личную информацию других пользователей или любых третьих лиц без их личного согласия;\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Не размещать любую информацию, нарушающую исключительные права пользователей или третьих лиц на объекты интеллектуальной собственности;\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Не преследовать иных Пользователей и не вступать в контакт с ними в случае выражения ими нежелания контакта с Пользователем;\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Администрация оставляет за собой право блокировать или удалять любой контент, неудовлетворяющий данному Соглашению.\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling",
      "bold": ""
    }
  }, [_vm._v("\n                5. Содержание сайта и права на него\n            ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-list', {
    attrs: {
      "number": ""
    }
  }, [_c('v-list-item', [_vm._v("\n                    Все объекты, размещенные на Сайте, в том числе элементы дизайна, текст, графические изображения, иллюстрации, видео, скрипты и другие объекты и их подборки, являются объектами исключительных прав Администрации, Пользователей и других правообладателей, все права на эти объекты защищены;\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Без предварительного письменного согласия Администрации или лица, передавшего Администрации права на Контент, Пользователь и/или третьи лица не имеют права распоряжаться любым способом элементами содержания Сайта и/или Контента;\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Размещая свой Контент на Сайте Пользователь предоставляет:\n                    "), _c('v-list', [_c('v-list-item', [_vm._v("\n                            Администрации - международную, неисключительную, бесплатную и передаваемую лицензию (с правом сублицензирования) на публичный показ, исполнение, воспроизведение, распространение, создание производных произведений, запись, сообщение в эфир, по кабелю, прокат, импорт, перевод, переработку и доведение до всеобщего сведения в рамках работы Сайта, в том числе для целей коммерческой деятельности Администрации, включая, среди прочего, продвижение и организацию Сайта полностью или частично (и производных его произведений) в любых медийных форматах и по любым средствам продвижения, в том числе в рекламно-информационных материалах Администрации;\n                        ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                            Другим Пользователям сайта - международную, неисключительную, бесплатную лицензию на доступ к Контенту через Сайт и на воспроизведение, распространение, создание производных произведений, демонстрацию:\n                            "), _c('v-list', [_c('v-list-item', [_vm._v("\n                                    Вышеуказанные лицензии, предоставленные Пользователем, являются бессрочными и безотзывными;\n                                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                                    Кроме своего собственного Контента, Пользователь не вправе загружать или иным образом доводить до всеобщего сведения (публиковать на Сайте) Контент других сайтов, баз данных и прочих объектов исключительных прав при отсутствии явным образом выраженного согласия правообладателя на такие действия;\n                                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                                    Законный правообладатель Контента, обоснованно считающий, что его права и интересы нарушены действиями Пользователя или третьих лиц в связи с размещением на Сайте такого контента, направляет подробное уведомление на Сайт через раздел «Контакты» на Сайте. В случае, если будут предоставлены все необходимые доказательства прав на Контент – такой Контент будет удален с Сайта.\n                                ")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling",
      "bold": ""
    }
  }, [_vm._v("\n                6. Взаимодействие с другими сайтами\n            ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-list', {
    attrs: {
      "number": ""
    }
  }, [_c('v-list-item', [_vm._v("\n                    Сайт может содержать гиперссылки на другие сайты, которые не находятся в собственности или связаны с Администрацией;\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Администрация не контролирует и не берет на себя никакой ответственности за содержание таких сайтов.\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling",
      "bold": ""
    }
  }, [_vm._v("\n                7. Изменения настоящего договора\n            ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-list', {
    attrs: {
      "number": ""
    }
  }, [_c('v-list-item', [_vm._v("\n                    Администрация может в одностороннем порядке изменять положения настоящего Соглашения. Обновленная версия настоящего Соглашения публикуются по следующему адресу:\n                    "), _c('v-link', {
    attrs: {
      "target": "_blank",
      "to": "http://unirate24.ru"
    }
  }, [_vm._v("\n                        http://unirate24.ru\n                    ")]), _vm._v(", который Пользователь обязан регулярно проверять;\n                ")], 1), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Если Пользователь продолжает пользоваться Сайтом после даты внесения изменений в положения настоящего Соглашения, то это рассматривается как понимание, согласие и принятие в полном объеме таких изменений.\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling",
      "bold": ""
    }
  }, [_vm._v("\n                8. Ответственность сторон\n            ")])], 1), _vm._v(" "), _c('div', [_c('v-list', {
    attrs: {
      "number": ""
    }
  }, [_c('v-list-item', [_vm._v("\n                    За неисполнение или ненадлежащее исполнение принятых на себя обязательств Стороны несут ответственность согласно действующему законодательству РФ и настоящему Соглашению;\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Пользователь соглашается с тем, что он единолично и в полном объеме несет ответственность за любое нарушение своих обязательств и условий настоящего Соглашения, за последствия любого такого нарушения, включая любой ущерб;\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Администрация не несет никакой ответственности перед Пользователем или какими-либо третьими лицами за любые нарушения Пользователями данного Соглашения;\n                ")]), _vm._v(" "), _c('v-list-item', [_vm._v("\n                    Пользователь принимает и соглашается с тем, что Администрация не несет никакой ответственности за любые убытки, которые возникли у Пользователя в результате использования Сайта или любой информации, расположенной на Сайте (в том числе Контента других Пользователей).\n                ")])], 1)], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68757944","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/modal/ModalUserAgreement/ModalUserAgreement.vue
// module id = 1211
// module chunks = 0